export const TABLE_TYPE = {
  TEXT: 'text',
  DATA: 'data',
  UNKNOWN: ''
}
